import { useCallback, useState } from 'react';

import { ICompany } from 'types/company';

import { updateCompany as updateCompanyFirebase } from 'services/api/firestore/client';

import { useUser } from 'hooks/auth/user';

export const useUpdateCompany = (companyId: string) => {
  const { user } = useUser();

  const [isLoading, setIsLoading] = useState(false);

  const updateCompany = useCallback(
    async (
      values: Partial<ICompany>,
      colors: string[] | undefined,
      logoPathLight?: string,
      logoPathDark?: string,
      logoPathQR?: string,
    ): Promise<boolean> => {
      if (!user) {
        return false;
      }

      setIsLoading(true);

      await updateCompanyFirebase({
        companyId,
        values,
        colors,
        logoPathLight,
        logoPathDark,
        logoPathQR,
      });

      setIsLoading(false);

      return true;
    },
    [companyId, user],
  );

  return {
    isLoading,
    updateCompany,
  };
};
